import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.BackButton', {
    back: 'Back to wallets',
    leaveWizardConfirmationTitle: 'Exiting the application form',
    leaveWizardConfirmationMessage: 'If you exit the application, the process will be saved.{br}Save and exit?',
    leaveWizardConfirmationCancel: 'Continue editing',
    leaveWizardConfirmationConfirm: 'Save and exit',
});
